import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchQboStatusRestoreAPI } from '@services/WebApiService';
import { canShowPagination } from '@utilities';

const qboFetchStatusRestoreAsync = createAsyncThunk(
  'QboStatusRestore/fetchStatusRestore',
  async ({ pageLink, query, top, skip, statuses }, { getState }) => {
    const { accessToken } = getState().auth;
    const data = await fetchQboStatusRestoreAPI(accessToken, pageLink, {
      query,
      top,
      skip,
      statuses,
    });
    return data;
  }
);

const { pending, fulfilled, rejected } = qboFetchStatusRestoreAsync;

const qboFetchStatusRestoreExtraReducers = {
  [pending]: (state) => {
    state.fetchingQboStatusRestore = true;
  },
  [rejected]: (state) => {
    state.fetchingQboStatusRestore = false;
  },
  [fulfilled]: (state, action) => {
    state.fetchingQboStatusRestore = false;

    if (action.payload.error) {
      state.error = action.payload.error;
    } else if (action.payload.value) {
      const showPagination = canShowPagination(state.QboStatusRestore.showPagination, action);

      state.QboStatusRestore = {
        value: action.payload.value,
        nextLink: action.payload.nextLink,
        prevLink: action.payload.prevLink,
        showPagination,
      };
    }
  },
};

export { qboFetchStatusRestoreAsync, qboFetchStatusRestoreExtraReducers };
